import { library, config } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
	faCalendarDays,
	faTv,
	faCocktail,
	faShower,
	faWifi,
	faAirConditioner,
	faBed,
	faChevronDown,
	faArrowRightLong,
	faChevronCircleLeft,
	faChevronCircleRight,
	faChevronUp,
	faHotTubPerson,
	faCoffee,
	faUtensils,
	faWineGlass,
	faStore,
	faBicycle,
	faCroissant,
	faCouch,
	faTree,
	faWater,
	faBath,
	faLink,
	faVault,
	faBuildingColumns,
	faSpa,
	faGolfFlagHole,
	faPersonHiking,
	faPersonSkiing,
	faMinus,
	faPlus,
	faMusic,
	faMasksTheater,
	faMicrophone,
	faTimes,
	faBars,
} from '@fortawesome/pro-light-svg-icons';
import { faCircleCheck, faLocationDot, faPhone, faEnvelope, faGlobe } from '@fortawesome/pro-regular-svg-icons';
import { faPlay, faSearch, faStar, faQuoteLeft, faStarHalf } from '@fortawesome/pro-solid-svg-icons';
import {
	faFacebook,
	faInstagram,
	faLinkedin,
	faPinterest,
	faSoundcloud,
	faSpotify,
	faTwitter,
	faWhatsapp,
	faYoutube,
} from '@fortawesome/free-brands-svg-icons';

// This is important, we are going to let Nuxt.js worry about the CSS
config.autoAddCss = false;

library.add(
	faGlobe,
	faBed,
	faTv,
	faUtensils,
	faWifi,
	faStore,
	faWineGlass,
	faCocktail,
	faMicrophone,
	faHotTubPerson,
	faCoffee,
	faAirConditioner,
	faShower,
	faChevronCircleLeft,
	faChevronCircleRight,
	faChevronUp,
	faChevronDown,
	faLocationDot,
	faCalendarDays,
	faArrowRightLong,
	faQuoteLeft,
	faBars,
	faEnvelope,
	faPhone,
	faTimes,
	faCircleCheck,
	faFacebook,
	faInstagram,
	faLinkedin,
	faPinterest,
	faPlay,
	faSoundcloud,
	faSpotify,
	faTwitter,
	faWhatsapp,
	faYoutube,
	faSearch,
	faStar,
	faStarHalf,
	faBicycle,
	faCroissant,
	faCouch,
	faTree,
	faWater,
	faBath,
	faLink,
	faVault,
	faBuildingColumns,
	faSpa,
	faGolfFlagHole,
	faPersonHiking,
	faPersonSkiing,
	faMusic,
	faMasksTheater,
	faMinus,
	faPlus,
);

export default defineNuxtPlugin(({ vueApp }) => {
	vueApp.component('font-awesome-icon', FontAwesomeIcon, {});
});
